import { render, staticRenderFns } from "./svg-icons-cmp.vue?vue&type=template&id=6fba34fa&scoped=true"
import script from "./svg-icons-cmp.vue?vue&type=script&lang=js"
export * from "./svg-icons-cmp.vue?vue&type=script&lang=js"
import style0 from "./svg-icons-cmp.vue?vue&type=style&index=0&id=6fba34fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fba34fa",
  null
  
)

export default component.exports